import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=137a3352&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=137a3352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a3352",
  null
  
)

export default component.exports